module.exports = __webpack_public_path__ + "static/img/05.836e9a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/05.png
// module id = oR2F
// module chunks = 0